__turbopack_context__.v({
  "containerDiv": "kV01uq_containerDiv",
  "mainButton": "kV01uq_mainButton",
  "subButton": "kV01uq_subButton",
});
